/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { BinderClaimPaymentHistoryResponseDto } from './BinderClaimPaymentHistoryResponseDto';
import {
    BinderClaimPaymentHistoryResponseDtoFromJSON,
    BinderClaimPaymentHistoryResponseDtoFromJSONTyped,
    BinderClaimPaymentHistoryResponseDtoToJSON,
    BinderClaimPaymentHistoryResponseDtoToJSONTyped,
} from './BinderClaimPaymentHistoryResponseDto';

/**
 * 
 * @export
 * @interface BinderClaimPaymentHistoryPaginationResponseDto
 */
export interface BinderClaimPaymentHistoryPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof BinderClaimPaymentHistoryPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<BinderClaimPaymentHistoryResponseDto>}
     * @memberof BinderClaimPaymentHistoryPaginationResponseDto
     */
    items: Array<BinderClaimPaymentHistoryResponseDto>;
}

/**
 * Check if a given object implements the BinderClaimPaymentHistoryPaginationResponseDto interface.
 */
export function instanceOfBinderClaimPaymentHistoryPaginationResponseDto(value: object): value is BinderClaimPaymentHistoryPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function BinderClaimPaymentHistoryPaginationResponseDtoFromJSON(json: any): BinderClaimPaymentHistoryPaginationResponseDto {
    return BinderClaimPaymentHistoryPaginationResponseDtoFromJSONTyped(json, false);
}

export function BinderClaimPaymentHistoryPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BinderClaimPaymentHistoryPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(BinderClaimPaymentHistoryResponseDtoFromJSON)),
    };
}

export function BinderClaimPaymentHistoryPaginationResponseDtoToJSON(json: any): BinderClaimPaymentHistoryPaginationResponseDto {
    return BinderClaimPaymentHistoryPaginationResponseDtoToJSONTyped(json, false);
}

export function BinderClaimPaymentHistoryPaginationResponseDtoToJSONTyped(value?: BinderClaimPaymentHistoryPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(BinderClaimPaymentHistoryResponseDtoToJSON)),
    };
}

